/**
 * Rounds-list rendering for LeagueDetailView. Pure HTML-string builder for the
 * "Rounds" tab: an empty state, or one card per round (newest first) linking to
 * the round detail view.
 */

import type { Round } from "../../types/index";

export const renderRoundsList = (rounds: Round[], leagueId: number): string => {
  if (rounds.length === 0) {
    return `
        <div class="text-center py-12 border-2 border-dashed border-slate-200 dark:border-slate-800 daylight:border-day-ink/10 rounded-xl">
          <span class="material-symbols-outlined text-5xl text-slate-300 dark:text-slate-700 mb-3 block">schedule</span>
          <p class="text-slate-600 dark:text-slate-400 daylight:text-day-ink-soft">No rounds scheduled yet</p>
        </div>
      `;
  }

  // Sort rounds by number descending
  const sortedRounds = [...rounds].sort((a, b) => b.roundNumber - a.roundNumber);

  return sortedRounds.map((round) => {
    const matchesCount = round.matches?.length || 0;
    const completedMatches = round.matches?.filter((m) => m.status === "reported").length || 0;
    const isCompleted = matchesCount > 0 && completedMatches === matchesCount;

    return `
        <div class="card hover:border-primary/50 transition-colors cursor-pointer group" onclick="window.location.hash = '#league/${leagueId}/rounds/${round.roundNumber}'">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <div class="flex items-center gap-3 mb-2">
                <span class="text-xl font-bold text-slate-900 dark:text-white daylight:text-day-ink group-hover:text-primary daylight:group-hover:text-day-ink transition-colors">Round ${round.roundNumber}</span>
                <span class="badge ${isCompleted ? 'badge-success' : 'badge-warning'}">
                  ${isCompleted ? 'Completed' : 'In Progress'}
                </span>
              </div>
              <div class="flex items-center gap-4 text-sm text-slate-600 dark:text-slate-400 daylight:text-day-ink-soft">
                <div class="flex items-center gap-1">
                  <span class="material-symbols-outlined text-base">sports_tennis</span>
                  <span>${matchesCount} Matches</span>
                </div>
                <div class="flex items-center gap-1">
                  <span class="material-symbols-outlined text-base">check_circle</span>
                  <span>${completedMatches} Reported</span>
                </div>
              </div>
            </div>
            <button class="btn-secondary group-hover:bg-primary group-hover:text-navy-800 group-hover:border-primary">
              <span class="material-symbols-outlined">arrow_forward</span>
            </button>
          </div>
        </div>
      `;
  }).join('');
};
